import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";

const DirectorsSlider = () => {
  const dispatch = useDispatch();
  const [directors, setDirectors] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.directors, // modifier selon le slicer
    isLoading: state.apiData?.loading?.directors,
  }));

  // Fetch directors data
  useEffect(() => {
    dispatch(fetchApiData({ url: "gallery-directions", itemKey: "directors" }));
  }, [dispatch]);

  // Mettre à jour la liste des directeurs
  useEffect(() => {
    if (data?.data && Array.isArray(data.data)) {
      setDirectors(data.data);
      setCurrentIndex(0);
    }
  }, [data]);

  // Slide automatique toutes les 4 secondes
  useEffect(() => {
    if (directors.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % directors.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [directors]);

  if (isLoading) {
    return (
      <div className="photo-week-card">
        {/* <div className="photo-week-header">
          <i className="pi pi-camera"></i> Directeurs ONPR
        </div> */}
        <div className="photo-week-loading">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  if (!directors.length) {
    return (
      <div className="photo-week-card">
        {/* <div className="photo-week-header">
          <i className="pi pi-camera"></i> Directeurs ONPR
        </div> */}
        <div className="photo-week-empty">
          <i
            className="pi pi-image"
            style={{ fontSize: "3rem", opacity: 0.3 }}
          ></i>
          <p>Aucun directeur disponible</p>
        </div>
      </div>
    );
  }

  const currentDirector = directors[currentIndex];

  const goNext = () => setCurrentIndex((prev) => (prev + 1) % directors.length);
  const goPrev = () =>
    setCurrentIndex((prev) => (prev - 1 + directors.length) % directors.length);

  return (
    <div className="photo-week-card">
      {/* <div className="photo-week-header">
        <i className="pi pi-camera"></i> Directeurs ONPR
      </div> */}

      <div className="slide-wrapper">
        <img
          key={currentDirector.id}
          src={currentDirector.image_url}
          alt={currentDirector.name_fr}
          className="photo-week-image"
        />
        {/* {directors.length > 1 && (
          <>
            <button className="nav-button prev" onClick={goPrev}>
              ❮
            </button>
            <button className="nav-button next" onClick={goNext}>
              ❯
            </button>
          </>
        )} */}
      </div>

      <div className="photo-caption">
        <h4>{currentDirector.name_fr}</h4>
        <p>{currentDirector.description_fr || " "}</p>
      </div>
    </div>
  );
};

export default DirectorsSlider;
